var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M180 40v40c0 22.093 17.91 40.001 40 40.001h40V220c0 11.046-8.954 20-20 20H40c-11.046 0-20-8.954-20-20V60c0-11.046 8.954-20 20-20zm20 0 60 60h-40c-11.045 0-20-8.954-20-20z"
})));
export default SvgFile;